// import MapboxDraw from "@mapbox/mapbox-gl-draw";
// import { useControl } from "react-map-gl";
// import type { MapRef, ControlPosition } from "react-map-gl";


// type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
//   position?: ControlPosition;
//   onCreate?: (evt: { features: object[] }) => void;
//   onUpdate?: (evt: { features: object[]; action: string }) => void;
//   onDelete?: (evt: { features: object[] }) => void;
// };

// export default function AnnotationControl(props: DrawControlProps) {
//   useControl<MapboxDraw>(
//     () => new MapboxDraw(props),
//     (context: MapContextValue) => {
//       const { map } = context;
// map.on("draw.create", props.onCreate as any);
// map.on("draw.update", props.onUpdate as any);
// map.on("draw.delete", props.onDelete as any);
//     },
//     (context: MapContextValue) => {
//       const { map } = context;
//       map.off("draw.create", props.onCreate as any);
//       map.off("draw.update", props.onUpdate as any);
//       map.off("draw.delete", props.onDelete as any);
//     },
//     {
//       position: props.position,
//     },
//   );

//   return null;
// }

// AnnotationControl.defaultProps = {
//   onCreate: () => {},
//   onUpdate: () => {},
//   onDelete: () => {},
// };

import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { useControl } from "react-map-gl";
import type { ControlPosition } from "react-map-gl";
import type { IControl } from "react-map-gl/dist/esm/types";

type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
  position?: ControlPosition;
  onCreate?: (evt: { features: object[] }) => void;
  onUpdate?: (evt: { features: object[]; action: string }) => void;
  onDelete?: (evt: { features: object[] }) => void;
};

export default function DrawControl(props: DrawControlProps) {
  useControl(
    () => new MapboxDraw(props) as unknown as IControl,
    ({ map }) => {
      map.on("draw.create", props.onCreate as any);
      map.on("draw.update", props.onUpdate as any);
      map.on("draw.delete", props.onDelete as any);
    },
    ({ map }) => {
      map.off("draw.create", props.onCreate as any);
      map.off("draw.update", props.onUpdate as any);
      map.off("draw.delete", props.onDelete as any);
    },
    {
      position: props.position,
    },
  );

  return null;
}
